import REQUIRED_FIELDS from '@/pages/events/REQUIRED_FIELDS';
import { site_state_$ilike } from '@/utils/query-helpers';
import usePagedQuery from '@/hooks/usePagedQuery';
import { STUDENT_IMPACT_MESSAGE, sumActualStudents } from '@/utils/studentImpact';

export default function useEventStudentImpact(network, schoolStart, schoolEnd, state) {
  const events = usePagedQuery('events', {
    where: {
      eager: {
        $where: {
          $and: REQUIRED_FIELDS.$and,
          // networkId: network?.id,
          ...site_state_$ilike(state),
          completed: true,
          createdAt: {
            $lte: schoolEnd,
            $gte: schoolStart
          }
        }
      }
    }
  }, { source: 'states-year/useEventStudentImpact', message: STUDENT_IMPACT_MESSAGE });

  const totalCount = sumActualStudents(events.data);

  return [
    events,
    totalCount
  ];
}
